import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '@/lib/cache'
import { toCamelCase } from '@/lib/typeHelper'
import { documentTableUrl, type PreviewDocument } from './previewDocument'

export interface DocumentTableSheet {
  /** Blank for a CSV, which has no sheets of its own. */
  name: string
  /** Square: every row is as wide as the widest. */
  rows: string[][]
  /** Every row the sheet has; `rows` stops at the preview's cap. */
  totalRows: number
}

export interface DocumentTable {
  fileName: string
  sheets: DocumentTableSheet[]
}

export function useDocumentTable(doc: PreviewDocument) {
  return useQuery({
    queryKey: [CacheKeys.DOCUMENT_TABLE, doc.documentId, doc.attachmentId ?? null],
    queryFn: () =>
      axios.get(documentTableUrl(doc)).then((response) => toCamelCase(response.data) as DocumentTable),
    // A stored file's cells never change, and a 4xx won't fix itself on a retry.
    staleTime: Infinity,
    retry: false,
  })
}
